__webpack_require__.p = "/marketplace-component-factory/referrals-hub/";